var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.projekt)?_c('div',[_c('mein-projekt',{attrs:{"onlyProjectId":_vm.isAuthorized && _vm.projektId}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }